/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { useAnalytics, tracker } from '@carvana/analytics';
import { isClient } from '../../utils/is-client';

export const SendInViewEvent = ({
  isLoading,
  component_name,
  data,
  triggerOnce = false,
  trackVisibility = false,
  delay = 100
}) => {
  if (!isClient()) return [];

  const { trackEvent } = useAnalytics();
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce,
    trackVisibility,
    delay
  });

  if (!isLoading && inView)
    trackEvent('component_in_view', { clickstream: { component_name, data } }, ['clickstream']);

  return [ref, inView];
};

export const OnSiteUnload = ({ AnalyticConfig } = {}) => {
  if (!isClient()) return;

  const track = tracker(AnalyticConfig);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      track('trackEvent', 'leave_support_center', {}, ['clickstream']);

      if (event.defaultPrevented) event.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [track]);
};
